var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitGenericNarCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_generic_x5F_nar_x5F_can",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14,90V6c0-2.209,1.791-4,4-4h60c2.209,0,4,1.791,4,4v84c0,2.209-1.791,4-4,4H18 C15.791,94,14,92.209,14,90z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,6v84H18V6H78 M78,4H18c-1.105,0-2,0.895-2,2v84c0,1.105,0.895,2,2,2h60c1.105,0,2-0.895,2-2V6C80,4.895,79.105,4,78,4 L78,4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitGenericNarCan);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_generic_nar_can.027723f23426c2a0c86403b6c51eb893.svg";
export { ForwardRef as ReactComponent };